module.exports = __webpack_public_path__ + "static/media/arrow-more.4999e3de.svg";